import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Nav, Row, Tab } from "react-bootstrap";
import MapView from "./MapView";
import { toast } from "react-toastify";
import { BIRD_EYE_VIEW } from "../../../services/ApiCalls";
import AssignDriverPop from "../../../components/Modals/AssignDriver";
import DriverListing from "./DriverListing";
import GoogleAutocomplete from "../../../components/Common/GoogleAutoComplete";

const BirdEyeView = () => {
  const [data, setData] = useState();
  const [assignDriverModel, setAssignDriverModel] = useState(false);
  const [viewData, setViewData] = useState();
  const handleAssignDriverModel = () => setAssignDriverModel((p) => !p);
  const [assignModelData, setAssignModelData] = useState();
  const [address, setAddress] = useState(null);
  const getData = async () => {
    try {
      const res = await BIRD_EYE_VIEW({
        location: {
          lng: address?.lng ? address?.lng : 76.6923227,
          lat: address?.lat ? address?.lat : 30.6999423,
        },
        bounds: {
          ne: {
            lat: 30.710607617125323,
            lng: 76.7343520921875,
          },
          sw: {
            lat: 30.698689214794772,
            lng: 76.7013931078125,
          },
        },
      });

      if (res?.data?.status === "success") {
        setData(res?.data?.data);
        setViewData(res?.data?.data?.available);
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  const filterHandler = (type) => {
    if (type === "available") {
      setViewData(data?.available);
    }
    if (type === "busy") {
      setViewData(data?.busy);
    }
  };

  useEffect(() => {
    getData();
  }, [address?.lat, address?.lng]);

  const handleAddress = (address) => {
    setAddress(address);
  };

  return (
    <>
      <AssignDriverPop
        assignDriverModel={assignDriverModel}
        setAssignDriverModel={handleAssignDriverModel}
        assignModelData={assignModelData}
      />
      <section className="birdEyeView py-3 position-realtive">
        <Container>
          <Row>
            <div className="map">
              <div
                className="mapWrpper"
                style={{
                  height: "600px",
                }}
              >
                <MapView
                  viewData={viewData}
                  lat={address?.lat}
                  data={data}
                  lng={address?.lng}
                  name={"address"}
                  handleAssignDriverModel={handleAssignDriverModel}
                  setAssignDriverModel={setAssignDriverModel}
                  setAssignModelData={setAssignModelData}
                  address={address}
                  onChange={(e) => {
                    console.log(e);
                    handleAddress(e);
                  }}
                />
              </div>
            </div>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default BirdEyeView;
